
const digest = 'cd2a3691b935cc2af3be6c5ccacc0a9122aa001aea5c3c6589a564f9c18d2b60';
const classes = {"wrapper":"_wrapper_1jafv_1","selected":"_selected_1jafv_12"};
const css = `._wrapper_1jafv_1 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}
._wrapper_1jafv_1 img {
  width: 30%;
}
._wrapper_1jafv_1 ._selected_1jafv_12 {
  border: 2px solid #2cb488;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  